import React, { useState } from 'react'
import { ArrowLeft, ShieldAlert, CheckCircle2, XCircle, Trophy, Sparkles } from 'lucide-react'

const HEADLINES = [
  {
    title: '«Científicos descubren que usar el móvil 10 horas al día aumenta el coeficiente intelectual en un 200%»',
    isFake: true,
    explanation: 'Bulo viral. El uso pasivo excesivo de pantallas está correlacionado con reducción de atención y fatiga cognitiva en estudios de la OCDE/PISA.',
    type: 'Sesgo de Algoritmo / Clickbait',
  },
  {
    title: '«Estudio PISA 2022 confirma caída en razonamiento matemático y lectura en más de 30 países miembros»',
    isFake: false,
    explanation: 'Real y verificado por la OCDE. Los datos oficiales muestran un rezago sin precedentes en competencias básicas tras la pandemia y uso desregulado de móviles.',
    type: 'Evidencia Científica',
  },
  {
    title: '«Beber agua con sal volcánica cura la miopía en 48 horas sin cirugía»',
    isFake: true,
    explanation: 'Desinformación médica peligrosa. No existe base científica para modificar la córnea o el globo ocular mediante ingesta salina.',
    type: 'Bulo Pseudocientífico',
  },
  {
    title: '«El entrenamiento de memoria de trabajo (Dual N-Back) mejora el control inhibitorio y la concentración»',
    isFake: false,
    explanation: 'Verificado por neurociencia cognitiva. La plasticidad cerebral responde al entrenamiento sistemático de funciones ejecutivas.',
    type: 'Neurociencia Aplicada',
  },
]

export function FakeNewsGame({ onBack, onComplete }) {
  const [index, setIndex] = useState(0)
  const [score, setScore] = useState(0)
  const [selected, setSelected] = useState(null)
  const [done, setDone] = useState(false)

  const current = HEADLINES[index]

  const handleChoice = (choiceIsFake) => {
    if (selected !== null) return
    const isCorrect = choiceIsFake === current.isFake
    setSelected(isCorrect ? 'correct' : 'wrong')

    if (isCorrect) {
      setScore((s) => s + 95)
    }

    setTimeout(() => {
      if (index + 1 >= HEADLINES.length) {
        setDone(true)
        onComplete?.(score + (isCorrect ? 95 : 0))
      } else {
        setIndex((i) => i + 1)
        setSelected(null)
      }
    }, 1800)
  }

  if (done) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh] p-6 text-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-gradient-to-tr from-rose-500 to-amber-500 flex items-center justify-center shadow-lg shadow-rose-500/30 animate-bounce">
          <Trophy size={40} className="text-white" />
        </div>
        <div>
          <span className="px-3 py-1 rounded-full bg-rose-950 border border-rose-500/40 text-rose-300 text-xs font-bold uppercase tracking-wider">
            Escudo Activado
          </span>
          <h2 className="text-2xl font-black text-white mt-2">¡Fake News Slayer!</h2>
          <p className="text-slate-400 text-xs mt-1">Cazador de desinformación certificado.</p>
        </div>

        <div className="p-4 rounded-2xl bg-slate-900 border border-slate-800 w-full max-w-xs space-y-2">
          <div className="flex justify-between text-xs text-slate-400">
            <span>Puntos de Civismo</span>
            <span className="text-emerald-400 font-bold">+{score} BP</span>
          </div>
          <div className="flex justify-between text-xs text-slate-400">
            <span>Inmunidad a Bulos</span>
            <span className="text-cyan-400 font-bold">100% Blindado</span>
          </div>
        </div>

        <button
          type="button"
          onClick={onBack}
          className="w-full max-w-xs py-3 rounded-xl bg-gradient-to-r from-rose-500 to-amber-500 text-white font-extrabold text-sm shadow-lg active:scale-95 transition-all cursor-pointer"
        >
          Volver al Hub
        </button>
      </div>
    )
  }

  return (
    <div className="p-4 flex flex-col min-h-[80vh] max-w-md mx-auto">
      {/* Top Header */}
      <div className="flex items-center justify-between mb-4">
        <button
          type="button"
          onClick={onBack}
          className="w-9 h-9 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-300 hover:text-white cursor-pointer active:scale-95"
        >
          <ArrowLeft size={18} />
        </button>

        <span className="text-xs font-bold text-rose-400 uppercase tracking-wide">
          Fake News Slayer
        </span>

        <span className="text-xs font-bold text-emerald-400">+{score} BP</span>
      </div>

      {/* Progress */}
      <div className="flex items-center justify-between text-[11px] text-slate-400 mb-1">
        <span>Titular {index + 1} de {HEADLINES.length}</span>
        <span className="text-rose-400 font-semibold">{current.type}</span>
      </div>
      <div className="w-full h-1.5 rounded-full bg-slate-800 mb-6 overflow-hidden">
        <div
          className="h-full bg-rose-500 rounded-full transition-all duration-300"
          style={{ width: `${((index + 1) / HEADLINES.length) * 100}%` }}
        />
      </div>

      {/* Headline Card */}
      <div className="flex-1 flex flex-col justify-center my-4">
        <div className="p-5 rounded-2xl bg-gradient-to-b from-[#18131e] to-[#120d18] border border-rose-900/40 shadow-xl relative overflow-hidden">
          <div className="flex items-center gap-2 text-rose-400 text-xs font-bold mb-3">
            <ShieldAlert size={16} />
            <span>¿Bulo / Fake News o Noticia Real?</span>
          </div>

          <p className="text-base font-bold text-white leading-relaxed">
            {current.title}
          </p>

          {selected && (
            <div
              className={`mt-4 p-3 rounded-xl border text-xs leading-relaxed animate-fade-in ${
                selected === 'correct'
                  ? 'bg-emerald-950/80 border-emerald-500/40 text-emerald-300'
                  : 'bg-rose-950/80 border-rose-500/40 text-rose-300'
              }`}
            >
              <div className="font-bold flex items-center gap-1.5 mb-1">
                {selected === 'correct' ? (
                  <>
                    <CheckCircle2 size={14} className="text-emerald-400" />
                    <span>¡Correcto! Análisis Verificado</span>
                  </>
                ) : (
                  <>
                    <XCircle size={14} className="text-rose-400" />
                    <span>¡Cuidado! Caíste en la trampa</span>
                  </>
                )}
              </div>
              <p>{current.explanation}</p>
            </div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <button
          type="button"
          onClick={() => handleChoice(true)}
          disabled={selected !== null}
          className="py-3.5 rounded-xl bg-rose-950/80 border border-rose-600/40 hover:bg-rose-900 text-rose-200 font-extrabold text-sm flex items-center justify-center gap-2 shadow-lg active:scale-95 transition-all cursor-pointer"
        >
          <XCircle size={18} />
          <span>¡ES BULO / FAKE!</span>
        </button>

        <button
          type="button"
          onClick={() => handleChoice(false)}
          disabled={selected !== null}
          className="py-3.5 rounded-xl bg-emerald-950/80 border border-emerald-600/40 hover:bg-emerald-900 text-emerald-200 font-extrabold text-sm flex items-center justify-center gap-2 shadow-lg active:scale-95 transition-all cursor-pointer"
        >
          <CheckCircle2 size={18} />
          <span>ES VERÍDICO</span>
        </button>
      </div>
    </div>
  )
}
